import { withNamespace } from "@/i18n/lazy-route"

/** Refund requests as staff review and pay them (LLD §9.20, Task 6.4), with the `adminRefunds` namespace. */
const translations = {
  en: () => import("@/i18n/locales/en/adminRefunds.json"),
  fr: () => import("@/i18n/locales/fr/adminRefunds.json"),
}

export const AdminRefundsScreen = withNamespace(
  "adminRefunds",
  () => import("./screens/AdminRefundsScreen"),
  translations,
)
export const AdminRefundScreen = withNamespace(
  "adminRefunds",
  () => import("./screens/AdminRefundScreen"),
  translations,
)
